import React, {useMemo} from 'react'
import {userSelectors} from '../../../store/user/userSelectors'
import {abbreviation, logout} from '../../../utils'
import {IUser} from '../../../types'
import {WuButton, WuPopover} from '@npm-questionpro/wick-ui-lib'
import styles from './UserBar.module.scss'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {GLOBAL} from '../../../Translation/English/global'

export const UserBar = (): React.JSX.Element => {
  const wt = useWt()

  const user = userSelectors.useCurrentUser() as IUser
  const initials = useMemo(
    () =>
      abbreviation(
        user?.firstname && user?.lastname
          ? `${user.firstname} ${user.lastname}`
          : (user?.emailAddress ?? ''),
      ),
    [user],
  )

  return (
    <div className={styles.userBarContainer}>
      <WuPopover
        Trigger={
          <div className={styles.userBarContainerButtonContent}>
            <div className={styles.userBarContainerButton}>{initials}</div>
          </div>
        }
      >
        <div className={styles.userBarContainerPopover}>
          <h4 className={styles.userBarContainerTitle}>
            {user?.firstname} {user?.lastname}
          </h4>
          <h6 className={styles.userBarContainerMail}>{user?.emailAddress}</h6>
          <h6 className={styles.userBarContainerCompany}>
            {user?.companyName}
          </h6>
          <div className={styles.userBarContainerFooter}>
            <WuButton className={styles.userBarContainerBtn} onClick={logout}>
              {wt(GLOBAL.logout)}
            </WuButton>
          </div>
        </div>
      </WuPopover>
    </div>
  )
}
